import { render, staticRenderFns } from "./PasswordRules.vue?vue&type=template&id=04f9769f&scoped=true&lang=pug"
import script from "./PasswordRules.vue?vue&type=script&lang=js"
export * from "./PasswordRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9769f",
  null
  
)

export default component.exports